import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {ExternalServiceType} from 'nutshell-graphql-types';
import type {
    GetPotentialMeetings as GetPotentialMeetingsQuery,
    GetPotentialMeetingsVariables as GetPotentialMeetingsQueryVariables,
} from 'nutshell-graphql-types';

import GET_POTENTIAL_MEETINGS from '../queries/get-potential-meetings.graphql';

export const useGetPotentialMeetings = (activityId: string, serviceType: ExternalServiceType) => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetPotentialMeetingsQuery, GetPotentialMeetingsQueryVariables>(
        GET_POTENTIAL_MEETINGS,
        {
            variables: {activityId, serviceType},
            fetchPolicy: 'cache-and-network',
        }
    );

    const {potentialMeetings} = makeDataDangerous(data);

    return {
        isLoading,
        potentialMeetings,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
